import 'babel-polyfill'

export { default as wrapRootElement } from './src/state/ReduxWrapper'
